import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7z3u3v384w: FaireBrandEntity = {
  token: "b_7z3u3v384w",
  type: "brand",
  name: "Nature's Hollow",
  avatarUrl:
    "https://cdn.faire.com/fastly/322f51fdb4567e4d10559ca3d9b24666855e52aad919ed0984319c5f07827aa8.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0542756b82b7f9e9dedd26ae2117994dbe6f570b9389b2239ddfd7b29d8308b3.png",
  logoUrl:
    "https://cdn.faire.com/fastly/322f51fdb4567e4d10559ca3d9b24666855e52aad919ed0984319c5f07827aa8.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0542756b82b7f9e9dedd26ae2117994dbe6f570b9389b2239ddfd7b29d8308b3.png",
  location: "Heber City, UT, USA",
  minimumOrderDollars: 120,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Our delicious HealthSmart® condiments were designed to help you and your family cut unnecessary amounts of sugar, calories and carbs from your diet, but do it without any compromise to outstanding flavor.",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:50.419Z",
    importedBy: "entity-db-cli",
  },
};
